import React from "react";
import "./GroupOpponentWaiting.css";
import coinImg from "../../assets/images/coiin.png";

const BattleInfoHeader = ({
  entryFee = 0,
  stateName = "Himachal Pradesh",
  subjectName = "Current Affairs",
}) => {
  return (
    <div className="examInfoBar">
      <div className="examInfoItem">
        <div className="examInfoIcon">
          <i className="fa-solid fa-coins"></i>
        </div>

        <div className="examInfoContent">
          <span className="examInfoLabel">Entry Fee</span>

          <div className="examInfoValue feeValue">
            <span className="coinIcon">
              <img src={coinImg} alt="" />
            </span>
            <span>{entryFee}</span>
          </div>
        </div>
      </div>

      <div className="examInfoDivider"></div>

      <div className="examInfoItem">
        <div className="examInfoIcon">
          <i className="bi bi-geo-alt-fill"></i>
        </div>

        <div className="examInfoContent">
          <span className="examInfoLabel">States</span>
          <span className="examInfoValue">{stateName}</span>
        </div>
      </div>

      <div className="examInfoDivider"></div>

      <div className="examInfoItem subjectItem">
        <div className="examInfoIcon">
          <i className="bi bi-book"></i>
        </div>

        <div className="examInfoContent">
          <span className="examInfoLabel">Subject</span>
          <span className="examInfoValue">{subjectName}</span>
        </div>
      </div>
    </div>
  );
};

export default BattleInfoHeader;
